module.exports = __webpack_public_path__ + "static/media/banner_img.e96f918c.png";